import { Image as ImageIcon, Video } from 'lucide-react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../../components/ui/dialog';
import { cn } from '../../../../lib/utils';
import { isVideoEntry, type MediaEntry } from '../../lib/mediaEntries';

interface MediaPreviewDialogProps {
  entry: MediaEntry | null;
  onOpenChange: (open: boolean) => void;
}

const MediaPreviewDialog = ({ entry, onOpenChange }: MediaPreviewDialogProps) => {
  const isVideo = entry ? isVideoEntry(entry) : false;

  return (
    <Dialog open={entry !== null} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          'max-h-[calc(100dvh-(--spacing(4)))] w-[calc(100%-1rem)] max-w-[calc(100%-1rem)]',
          'overflow-hidden rounded-2xl p-0 sm:max-w-5xl'
        )}
      >
        <DialogHeader className="shrink-0 border-b border-border-subtle px-5 py-4">
          <DialogTitle className="truncate pr-8 font-display text-base font-bold text-brand-navy">
            {entry?.name ?? 'Vista previa'}
          </DialogTitle>
        </DialogHeader>

        <div className="min-h-0 overflow-auto bg-bg-surface-raised p-4">
          {entry?.publicFileURL && isVideo && (
            <video
              className={cn('max-h-[calc(100dvh-(--spacing(24)))] w-full rounded-lg bg-black', 'sm:max-h-[75vh]')}
              controls
              src={entry.publicFileURL}
            >
              <track kind="captions" />
            </video>
          )}

          {entry?.publicFileURL && !isVideo && (
            <img
              alt={entry.name}
              className={cn('max-h-[calc(100dvh-(--spacing(24)))] w-full rounded-lg object-contain', 'sm:max-h-[75vh]')}
              src={entry.publicFileURL}
            />
          )}

          {!entry?.publicFileURL && (
            <div className="flex h-80 flex-col items-center justify-center gap-3 text-brand-vivid">
              {isVideo ? <Video className="size-12" /> : <ImageIcon className="size-12" />}
              <p className="m-0 text-sm font-semibold text-text-muted">No hay URL pública para previsualizar.</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MediaPreviewDialog;
